import { render, staticRenderFns } from "./ContentLayout.vue?vue&type=template&id=6ad11a60&scoped=true&"
var script = {}
import style0 from "./ContentLayout.vue?vue&type=style&index=0&id=6ad11a60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad11a60",
  null
  
)

export default component.exports